import history from "./history";
export const goToRoute = (route: string, data: any = {}) => history.push(route, data);
export const replaceRoute = (route: string) => history.replace(route);
